import React, { useContext } from "react";
import AppContext from "context/Context";
import { useTranslation } from "react-i18next";
import UpliftCss from "../common/upliftcss.module.css";

const PageTitle = ({ menuName }) => {
	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();

	return (
		<div className={`mb-3  ${UpliftCss.marginTop25}`}>
			<div className={` ${isRTL ? UpliftCss.gradiantTitleAr : UpliftCss.gradiantTitle}`}>
				<div className="col-md">
					<h5 className="mb-2 mb-md-0">{t(menuName)}</h5>
				</div>
			</div>
		</div>
	);
};

export default PageTitle;
